import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { SirenIcon } from 'lucide-react';
import { Hero } from './components/Hero';
import { PricingPanel } from './components/PricingPanel';
import { RequestForm } from './components/RequestForm';
import { ContactSection } from './components/ContactSection';
import { EmergencyModal } from './components/EmergencyModal';
export function App() {
  const [isEmergencyOpen, setIsEmergencyOpen] = useState(false);
  return <div className="min-h-screen w-full bg-[#e8eee8] px-0 py-0 md:px-6 md:py-10" data-id="element-0" data-mp="2mlu5ue0ah7o0">
      <main className="mx-auto min-h-screen w-full max-w-[480px] bg-white px-5 pb-28 pt-5 md:min-h-0 md:rounded-[32px] md:px-6 md:py-6 md:shadow-[0_20px_70px_rgba(37,51,42,0.16)]" data-id="element-1" data-mp="2mjzlp1wudjkz">
        <motion.div initial="hidden" animate="visible" variants={{
        hidden: {
          opacity: 0
        },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.08
          }
        }
      }} data-id="element-2" data-mp="2wip7h5ruzo6i">
          <motion.div variants={{
          hidden: {
            y: 12,
            opacity: 0
          },
          visible: {
            y: 0,
            opacity: 1
          }
        }} data-id="element-3" data-mp="3mlj6wpc9h30f">
            <Hero data-id="element-4" data-mp="5ggxfcks0yi" />
          </motion.div>
          <motion.div className="mt-5" variants={{
          hidden: {
            y: 12,
            opacity: 0
          },
          visible: {
            y: 0,
            opacity: 1
          }
        }} data-id="element-5" data-mp="2zld1d7i6tbah">
            <PricingPanel data-id="element-6" data-mp="38o4d78ez692n" />
          </motion.div>
          <motion.div className="mt-4" variants={{
          hidden: {
            y: 12,
            opacity: 0
          },
          visible: {
            y: 0,
            opacity: 1
          }
        }} data-id="element-7" data-mp="3dlw9sfqkejd6">
            <RequestForm data-id="element-8" data-mp="35oy8u9shaup" />
          </motion.div>
          <motion.div className="mt-5 hidden md:block" variants={{
          hidden: {
            y: 12,
            opacity: 0
          },
          visible: {
            y: 0,
            opacity: 1
          }
        }} data-id="element-9" data-mp="38kvshhq5xim">
            <button type="button" onClick={() => setIsEmergencyOpen(true)} className="flex w-full items-center justify-center gap-2 rounded-xl bg-emerald-500 px-4 py-4 text-[15px] font-extrabold text-slate-950 transition-transform hover:bg-emerald-400 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-emerald-600 focus:ring-offset-2" data-id="element-10" data-mp="83qgjcze5654">
              <SirenIcon className="h-5 w-5" aria-hidden="true" data-id="element-11" data-mp="3limqsg4951eu" />
              SOS • Викликати евакуатор
            </button>
          </motion.div>
          <motion.div className="mt-5" variants={{
          hidden: {
            y: 12,
            opacity: 0
          },
          visible: {
            y: 0,
            opacity: 1
          }
        }} data-id="element-12" data-mp="2sur0bt5a05qi">
            <ContactSection data-id="element-13" data-mp="ygd43zne4wn3" />
          </motion.div>
          <motion.footer className="mt-8 text-center text-[11px] font-medium text-slate-400" variants={{
          hidden: {
            opacity: 0
          },
          visible: {
            opacity: 1
          }
        }} data-id="element-14" data-mp="ydikubg45hv9">
            Сайт зроблено з{' '}
            <span className="font-bold text-slate-500" data-id="element-15" data-mp="1i3uj0ez7frl4">Linkery</span>
          </motion.footer>
        </motion.div>
      </main>

      <div className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 p-3 backdrop-blur md:hidden" data-id="element-16" data-mp="1m44rpzedsw3o">
        <button type="button" onClick={() => setIsEmergencyOpen(true)} className="flex w-full items-center justify-center gap-2 rounded-xl bg-emerald-500 py-4 text-[15px] font-extrabold text-slate-950 shadow-sm transition-transform active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-emerald-600 focus:ring-offset-2" data-id="element-17" data-mp="6mul93u38kjp">
          <SirenIcon className="h-5 w-5" aria-hidden="true" data-id="element-18" data-mp="h6knkrllgdzh" />
          SOS • Викликати евакуатор
        </button>
      </div>

      <EmergencyModal open={isEmergencyOpen} onClose={() => setIsEmergencyOpen(false)} data-id="element-19" data-mp="c9u7i49shie2" />
    </div>;
}